import React, { Component } from 'react';
import Loader from 'react-loader-spinner';
import "react-table-6/react-table.css";
import $ from 'jquery';
import { ToastContainer, toast } from "react-toastify";

import { DialogComponent } from '@syncfusion/ej2-react-popups';

export default class BasicSettings extends Component {
    constructor() {
        super();
        this.state = {
            canSell: false,
            data: [],
            successResp: true,
            botIconFile: null,
            botBannerFile: null,
            fields: {},
            editable: true,
            isBotIconFileSelected: false,
            isBotBannerFileSelected: false,
            botIntroName: null,
            botIntroMimeType: null,
            botBannerName: null,
            botBannerMimeType: null,
            keywordList: [],
            hideDeletePopup: false,
            id: '',
            appPresent: false,
            isDeployed: false,
        }
        this.saveImageSrc = "./assets/images/baseline_save_white_24dp.png";
        this.editImageSrc = "./assets/images/edit2.png";
        this.settings = { effect: 'Zoom', duration: 400, delay: 0, position: 'center' };
        this.buttons = [{
            buttonModel: {
                content: 'Yes',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': (props) => {
                this.deleteStoreDate(this.state.id)
            }
        },
        {
            buttonModel: {
                content: 'No',
                cssClass: 'e-flat',
                isPrimary: true,
            },
            'click': () => {
                this.setState({ hideDeletePopup: false });
            }
        }];
        this.dialogClose = () => {
            this.setState({
                hideDeletePopup: false,
            });
        };
    }

    componentDidMount() {
        var thisController = this;
        setTimeout(() => {
            thisController.fetchStoreDataApi();
            thisController.fetchProjectDetailsApi();
        }, 300);

        document.addEventListener("projectChanged", function (event) {
            thisController.projectId = event.projectId;
            thisController.state.editable = true;
            thisController.state.canSell = false;
            thisController.setState(thisController.state);
            thisController.fetchStoreDataApi(event.projectId);
            thisController.fetchProjectDetailsApi(event.projectId);
        });
    }

    checkHandleSellInBotStoreApi = (e) => {
        var detailsController = this;
        if (detailsController.validateListed()) {
            var data = { "appId": detailsController.state.id, "listed": e.target.checked }
            $.ajax({
                url: "/api/app-listed-info",
                type: 'POST',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-type": "application/x-www-form-urlencoded; charset=utf-8"
                },
                data: data,
                success: function (res) {
                    if (res.success === true) {
                        detailsController.fetchStoreDataApi();
                        if (res.result.listed) {
                            detailsController.notifySuccessToast("App " + res.result.name + " added to botstore successfully");
                        } else {
                            detailsController.notifySuccessToast("App " + res.result.name + " removed from botstore successfully");
                        }
                    } else {
                        detailsController.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status === 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    fetchProjectDetailsApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var detailsController = this;
        $.ajax({
            url: "/api/project-details",
            async: false,
            method: 'GET',
            data: {
                "projectId": projectId
            },
            headers: { "Authorization": "Bearer " + localStorage.getItem("access_token") },
            success: function (res) {
                if (res.success === true) {
                    if (res.result.deployed == true) {
                        detailsController.state.isDeployed = true;
                    } else {
                        detailsController.state.isDeployed = false;
                    }
                } else {
                    detailsController.state.isDeployed = false;
                }
                detailsController.setState(detailsController.state);
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/";
                }
            }
        });
    }

    onChangeBotIconFile = (event) => {
        var storeComponent = this;
        var reader = new FileReader();
        let fileSize = (event.target.files[0].size) / 1000;
        if (fileSize <= 512) {
            storeComponent.state.isBotIconFileSelected = true;
            reader.onloadend = () => {
                storeComponent.state.botIconFile = reader.result;
                storeComponent.setState(storeComponent.state);
            }
            reader.readAsDataURL(event.target.files[0]);
            storeComponent.state.botIntroMimeType = event.target.files[0].type;
            storeComponent.state.botIntroName = event.target.files[0].name;
            storeComponent.setState(storeComponent.state);
        } else {
            storeComponent.notifyImageSize();
        }
    }

    onChangeBotBannerFile = (event) => {
        var storeComponent = this;
        var reader = new FileReader();
        let fileSize = (event.target.files[0].size) / 1000;
        if (fileSize < 512) {
            storeComponent.state.isBotBannerFileSelected = true;
            reader.onloadend = () => {
                storeComponent.state.botBannerFile = reader.result;
                storeComponent.setState(storeComponent.state);
            }
            reader.readAsDataURL(event.target.files[0]);
            storeComponent.state.botBannerMimeType = event.target.files[0].type;
            storeComponent.state.botBannerName = event.target.files[0].name;
            storeComponent.setState(storeComponent.state);
        } else {
            storeComponent.notifyImageSize();
        }
    }

    notifyImageSize() {
        document.getElementById("logo").value = '';
        toast(<b>File too Big, please select a file less than 512KB</b>, {
            position: "top-center",
        });
    }


    fetchStoreDataApi = (projectId) => {
        if (!projectId) {
            projectId = this.projectId;
            if (!projectId) {
                projectId = localStorage.getItem('currentProjectId');
            }
        }
        var storeComponent = this;
        storeComponent.state.keywordList = [];
        $.ajax({
            url: "/api/app",
            async: false,
            method: 'GET',
            data: {
                templateProjectId: projectId,
            },
            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    storeComponent.state.fields = res.result.app;
                    storeComponent.state.id = res.result.app.id;
                    if (Object.keys(res.result.app).length > 0) {
                        if (res.result.app.keywords.includes(",")) {
                            storeComponent.state.keywordList = res.result.app.keywords.split(",");
                        }
                        storeComponent.state.canSell = res.result.app.listed;
                        storeComponent.state.appPresent = true;
                        storeComponent.state.botIntroMimeType = res.result.botIntroMimeType;
                        storeComponent.state.botBannerMimeType = res.result.botBannerMimeType;
                        storeComponent.state.botIntroName = res.result.botIntroName;
                        storeComponent.state.botBannerName = res.result.botBannerName;
                        storeComponent.state.isBotIconFileSelected = true;
                        storeComponent.state.isBotBannerFileSelected = true;
                        storeComponent.state.editable = false;
                        storeComponent.state.botIconFile = res.result.botIntroData;
                        storeComponent.state.botBannerFile = res.result.botBannerData;
                        storeComponent.setState(storeComponent.state);
                    }
                } else {
                    storeComponent.state.appPresent = false;
                    storeComponent.state.canSell = false;
                    storeComponent.state.fields = {};
                    storeComponent.state.isBotBannerFileSelected = false;
                    storeComponent.state.isBotIconFileSelected = false;
                    storeComponent.state.botIntroMimeType = null;
                    storeComponent.state.botBannerMimeType = null;
                    storeComponent.state.botIntroName = null;
                    storeComponent.state.botBannerName = null;
                    storeComponent.state.editable = true;
                    if (document.getElementById("basicSettingName") != null) {
                        document.getElementById("basicSettingName").value = "";
                        document.getElementById("basicSettingDescrption").value = "";
                        document.getElementById("supportEmail").value = "";
                        document.getElementById("supportPhoneNumber").value = "";
                        document.getElementById("website").value = "";
                        document.getElementById("keywords").value = "";
                        document.getElementById("planRate").value = "";
                        document.getElementById("bot-icon-input").value = "";
                        document.getElementById("bot-banner-input").value = "";
                    }
                    storeComponent.setState(storeComponent.state);
                }
            },
            error: function (xhr) {
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    validateListed = () => {
        var detailsController = this;
        if (detailsController.state.isDeployed == false) {
            detailsController.state.canSell = false;
            detailsController.setState(detailsController.state);
            detailsController.notifyInvalidFields("Please Deploy Your Project Before Selling ");
            return false;
        } else if (detailsController.state.appPresent == false) {
            detailsController.state.canSell = false;
            detailsController.setState(detailsController.state);
            detailsController.notifyInvalidFields("Please Save The Basic App Details Before Selling");
            return false;
        } else {
            return true;
        }
    }


    deleteStoreDate = (id) => {
        var storeComponent = this;
        storeComponent.state.keywordList = [];
        $.ajax({
            url: "/api/app/" + id,
            async: false,
            method: 'DELETE',

            headers: {
                "Authorization": "Bearer " + localStorage.getItem("access_token"),
            },
            success: function (res) {
                if (res.success === true) {
                    storeComponent.setState({ hideDeletePopup: false });
                    storeComponent.notifySuccessToast("Deleted Successfully");
                    storeComponent.fetchStoreDataApi();

                } else {
                    storeComponent.notifyFailToLoad(res.result);
                }
            },
            error: function (xhr) {
                var errorMessage = xhr.status + ': ' + xhr.statusText
                if (xhr.status == 401) {
                    window.location.href = "/platform/";
                }
            }
        });
    }

    validateBasicSetting = () => {
        let fields = this.state.fields;
        var pattern = new RegExp(/^([a-zA-Z0-9_\-\.]+)@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.)|(([a-zA-Z0-9\-]+\.)+))([a-zA-Z]{1,5}|[0-9]{1,3})(\]?)$/);
        const numberRegex = /^[0-9\b]+$/;
        if (!fields["name"] || fields["name"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields");
            return false;
        } else if (!fields["description"] || fields["description"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields");
            return false;
        } else if (!fields["supportEmail"] || fields["supportEmail"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields");
            return false;
        } else if (!pattern.test(fields["supportEmail"])) {
            this.notifyInvalidFields("Please enter valid support email address");
            return false;
        } else if (!fields["supportPhoneNumber"] || fields["supportPhoneNumber"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields");
            return false;
        } else if (!numberRegex.test(fields["supportPhoneNumber"])) {
            this.notifyInvalidFields("Please enter valid support phone number");
            return false;
        } else if (!fields["website"] || fields["website"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields");
            return false;
        } else if (!fields["website"].match(/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g)) {
            this.notifyInvalidFields("Please enter valid website address");
            return false;
        } else if (!fields["keywords"] || fields["keywords"].trim() == "") {
            this.notifyInvalidFields("Please fill all the fields")
            return false;
        } else if (!fields["planRate"] || fields["planRate"] == "") {

            this.notifyInvalidFields("Please fill all the fields");
            return false;

        } else if (fields["planRate"] < 0.8 || fields["planRate"] > 10) {
            this.notifyInvalidFields("Plan rate should be greater than 70 paise and less than Rs.10")
            return false;
        } else if (this.state.botIconFile == undefined || this.state.botIconFile == null || this.state.botIconFile == "") {
            this.notifyInvalidFields("Please upload bot introductory file")
            return false;
        } else if (this.state.botBannerFile == undefined || this.state.botBannerFile == null || this.state.botBannerFile == "") {
            this.notifyInvalidFields("Please upload bot banner file")
            return false;
        } else {
            return true;
        }
    }

    notifyInvalidFields = (message) => {
        toast.dismiss();
        toast(<b> <img src="assets/images/warn.svg"
            style={{ paddingRight: '0px', height: '20px', width: '20px' }}
            content="" /> &nbsp;&nbsp; {message}</b >, {
            position: "top-center"
        });
    }

    saveBotBasicDetailsApi = () => {
        let basicSettingsComp = this;
        if (basicSettingsComp.validateBasicSetting()) {
            let app = basicSettingsComp.state.fields;
            app["templateProjectId"] = localStorage.getItem("currentProjectId");
            app["developerId"] = JSON.parse(localStorage.getItem("user_details")).userId;
            app["listed"] = basicSettingsComp.state.canSell;
            let appDto = {
                app: app,
                botIntroName: basicSettingsComp.state.botIntroName,
                botIntroMimeType: basicSettingsComp.state.botIntroMimeType,
                botIntroData: basicSettingsComp.state.botIconFile,
                botBannerName: basicSettingsComp.state.botBannerName,
                botBannerMimeType: basicSettingsComp.state.botBannerMimeType,
                botBannerData: basicSettingsComp.state.botBannerFile
            }
            $.ajax({
                url: "/api/app",
                type: 'POST',
                async: false,
                headers: {
                    "Authorization": "Bearer" + localStorage.getItem("access_token"),
                    "Content-Type": "application/json"
                },
                data: JSON.stringify(appDto),
                success: function (res) {
                    if (res.success === true) {
                        basicSettingsComp.notifySuccessToast("Basic Settings added Successfully");
                        basicSettingsComp.fetchStoreDataApi();
                    } else {
                        basicSettingsComp.notifyFailToLoad(res.result);
                    }
                },
                error: function (xhr) {
                    if (xhr.status == 401) {
                        window.location.href = "/";
                    }
                }
            });
        }
    }

    notifySuccessToast(response) {
        toast.dismiss();
        toast(<b>
            <img src="./assets/images/done.svg" style={{ paddingRight: '0px' }} content="" />
            &nbsp;&nbsp;{response}</b>, {
            position: "top-center"
        });
    }

    notifyFailToLoad(response) {
        toast.dismiss();
        toast(<b style={{ color: "red" }}>{response}</b>, {
            position: "top-center",
            color: "red"
        });
    }

    handleChange = (e) => {
        let fields = this.state.fields;
        fields[e.target.name] = e.target.value;
        this.setState({
            fields
        });
    }

    editBasicSettings = () => {
        this.state.editable = true;
        this.setState(this.state);
    }

    refreshData = () => {
        this.setState(this.state);
        this.fetchStoreDataApi();
    }
    deleteCall = () => {
        this.deleteStoreDate(this.state.propsId);
    }
    render() {
        let $botIntroIcon = (<div className="previewText image-container" style={{ color: "black", marginTop: '20px', }}>
            *file size should be less than 512KB<br /><br />
            (Supports jpg,jpeg,png,svg,gif format)</div>);
        if (this.state.isBotIconFileSelected) {
            $botIntroIcon = (<div className="image-container">
                {<img id="bot-icon" src={this.state.botIconFile} alt="icon" width="350" height="175" />}
            </div>);
        }

        let $botBannerFile = (<div className="previewText image-container" style={{ color: "black", marginTop: '20px' }}>
            *file size should be less than 512KB<br /><br />
            (Supports jpg,jpeg,png,svg,gif format)</div>);
        if (this.state.isBotBannerFileSelected) {
            $botBannerFile = (<div className="image-container">
                {<img id="bot-banner" src={this.state.botBannerFile} alt="icon" width="512" height="512" />}
            </div>);
        }


        return (
            <div>
                <Loader
                    type="TailSpin"
                    color="#282a65"
                    visible={!this.state.successResp}
                    height={300}
                    width={50}
                    style={{ textAlign: 'center' }}
                />

                <ToastContainer className="Toast-at-center" />

                <div style={{ background: "#F9F9FB", display: this.state.successResp ? 'block' : 'none' }} className="container-fluid">
                    {/* for toaster */}
                    <link rel="stylesheet" href="assets/css/ReactToastify.css" />

                    <link rel="stylesheet" href="assets/css/material.css" />
                    <link rel="stylesheet" href="assets/css/buttonForm.css" />
                    <link rel="stylesheet" href="plugins/font-awesome/css/font-awesome.min.css" />

                    {/* for reactTable */}
                    <link rel="stylesheet" href="assets/css/React_Table_CSS/react-table.css" />
                    <link rel="stylesheet" href="assets/css/toggleButton.css" />

                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-sm-6">
                                <h6 className="nav-item" style={{
                                    color: '#282a65',
                                    marginTop: '24px', marginLeft: '-4px'
                                }}>Basic Settings</h6>
                            </div>
                            {/* Add button and refresh button*/}
                            <div className="col-sm-5" Align='right'>
                                <span style={{ fontSize: '16px', fontWeight: '500', marginRight: '15px' }}>Sell in botstore</span>
                                <label class="switch">
                                    <input type="checkbox"
                                        checked={this.state.canSell} onChange={this.checkHandleSellInBotStoreApi}
                                        style={{ width: '150px', color: '#282a65' }}
                                    />
                                    <span class="slider round" ></span>
                                </label>

                                <button className="btn action-button " style={{ marginLeft: '13px' }}
                                    title="Add"
                                    id="addMsg"
                                    onClick={this.state.editable ? this.saveBotBasicDetailsApi : this.editBasicSettings}
                                ><img src={this.state.editable ? this.saveImageSrc : this.editImageSrc} />
                                </button>
                                <button onClick={this.refreshData} className="btn action-button" title="Refresh" >
                                    <img src="./assets/images/refresh_white_24dp.png"></img>
                                </button>
                            </div>
                            <div className="col-sm-1" Align='right'>

                                <button disabled={!this.state.appPresent} onClick={() => {
                                    this.setState({
                                        hideDeletePopup: true,
                                    })
                                }} className="btn action-button" title="Delete">
                                    <img src="./assets/images/baseline_delete_white_24dp.png" ></img>
                                </button>
                            </div>

                        </div>
                    </div>

                    <div className="card-body p-0 mb-25">
                        <div className="tab-content col-12 p-0">
                            <div className="card card-primary mt-3">
                                <div style={{ marginLeft: "30px", marginTop: "10px" }} className="raiseTicketLable">
                                    <div className="col-sm-12" style={{ marginTop: "10px", marginBottom: '50px' }}>
                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Name:</div>
                                                <input className="col-sm-8"
                                                    type="text"
                                                    name="name" id="basicSettingName" placeholder="Enter Bot Name"
                                                    disabled={!this.state.editable}
                                                    value={this.state.fields.name}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Description:</div>
                                                <input
                                                    type="text" className="col-sm-8"
                                                    name="description" id="basicSettingDescrption" placeholder="Enter Bot Description"
                                                    value={this.state.fields.description}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Support Email:</div>
                                                <input className="col-sm-8"
                                                    type="email" id="supportEmail"
                                                    name="supportEmail" placeholder="Enter Support Email"
                                                    value={this.state.fields.supportEmail}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Support PhoneNumber:</div>
                                                <input
                                                    type="text" id="supportPhoneNumber" className="col-sm-8"
                                                    name="supportPhoneNumber" placeholder="Enter Support PhoneNumber"
                                                    disabled={!this.state.editable}
                                                    value={this.state.fields.supportPhoneNumber}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                            <div className="row" style={{ marginTop: '30px', paddingLeft: '7.5px' }}>
                                                <div>
                                                    <div className="form-group">
                                                        <span>Bot Intro Image</span>
                                                        <div className="imgPreview" >
                                                            {$botIntroIcon}
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div>
                                                            <input id="bot-icon-input" type="file" name="bot-icon-input"
                                                                accept="image/x-png,image/gif,image/jpeg"
                                                                disabled={!this.state.editable}
                                                                onChange={this.onChangeBotIconFile}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                        </div>

                                        <div className="col-sm-6">
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Website:</div>
                                                <input
                                                    type="text" id="website" className="col-sm-8"
                                                    name="website" placeholder="Enter Website Name"
                                                    disabled={!this.state.editable}
                                                    value={this.state.fields.website}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>
                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Keywords:</div>
                                                <input
                                                    type="text" id="keywords" className="col-sm-8"
                                                    name="keywords" placeholder="Enter Keywords"
                                                    value={this.state.fields.keywords}
                                                    disabled={!this.state.editable}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2',
                                                        display: this.state.keywordList.length > 1 && !this.state.editable ? 'none' : 'block'
                                                    }}
                                                />
                                                <div className="row col-sm-8" style={{
                                                    padding: '0.375rem 0.75rem',
                                                    textAlign: 'left',
                                                    display: this.state.keywordList.length > 1 && !this.state.editable ? 'flex' : 'none'
                                                }}>
                                                    {this.state.keywordList.map((keyword) => (
                                                        <button style={{ marginRight: '5px' }} disabled={true} className="bubble">{keyword}&nbsp;&nbsp;</button>
                                                    ))}
                                                </div>
                                            </div>

                                            <div className="row" style={{ marginTop: '20px' }}>
                                                <div className="col-sm-3" align="left" style={{ marginTop: '10px' }}>Plan Rate:</div>
                                                <input
                                                    id="planRate" className="col-sm-8"
                                                    name="planRate" placeholder="Enter Plan Rate between ₹1 to ₹10"
                                                    disabled={!this.state.editable}
                                                    value={this.state.fields.planRate}
                                                    onChange={this.handleChange}
                                                    style={{
                                                        padding: '0.375rem 0.75rem', textAlign: 'left',
                                                        borderBottom: !this.state.editable ? "1px solid #ffffff" : '1px solid #b2b2b2'
                                                    }} />
                                            </div>


                                            <div className="row" style={{ marginTop: '30px', paddingLeft: '7.5px' }}>

                                                <div>
                                                    <div className="form-group" style={{ marginTop: '14%' }}>
                                                        <span>Bot preview image</span>
                                                        <div className="imgPreview">
                                                            {$botBannerFile}
                                                        </div>
                                                    </div>
                                                    <div className="form-group">
                                                        <div>
                                                            <input id="bot-banner-input" type="file" name="bot-banner-input"
                                                                accept="image/x-png,image/gif,image/jpeg"
                                                                disabled={!this.state.editable}
                                                                onChange={this.onChangeBotBannerFile}
                                                            />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>

                                </div>
                            </div>
                        </div>
                    </div>
                    <DialogComponent width='400px' style={{}} animationSettings={this.settings}
                        header='Basic App Details' showCloseIcon={true} buttons={this.buttons}
                        ref={dialog => this.dialogInstance = dialog}
                        visible={this.state.hideDeletePopup} close={this.dialogClose}>
                        <img src="assets/images/warn.svg" style={{ paddingRight: '0px', height: '20px', width: '20px' }}
                            content="" />&nbsp;Do you want to delete basic app details?<br />
                        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Note: Press 'Yes' to delete or press 'No' to decline.</DialogComponent>
                </div >
            </div >
        );
    }
}




// WEBPACK FOOTER //
// ./src/projectmgmt/testAndDeploy/appStore/BasicSettings.js